<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Pesquisar Clientes"/>
            <breadcrumb :items="[{label: 'Pesquisa de Clientes', path: 'customers'}]"/>

            <form @submit.prevent.stop="submit">
                <ibox>
                    <template v-slot:title v-if="!$appUtils.isMobile()">
                        <h5>Filtros de Pesquisa</h5>
                    </template>

                    <template v-slot:content>
                        <div v-if="$appUtils.isDesktop() || filterMode" class="container-fluid-grid">
                            <div class="form-row" v-if="!$appUtils.isMobile() || filterMode">
                                <div class="col-md-3 form-group">
                                    <label for="customerSearchName">Nome</label>
                                    <input id="customerSearchName" type="text" class="form-control form-control-sm"
                                           v-model="search_params.query"/>
                                </div>
                                <div class="col-md-2 form-group">
                                    <label for="customerSearchGroup">Grupo</label>
                                    <select id="customerSearchGroup" v-model="search_params.customer_group_id" class="form-control form-control-sm">
                                        <option value="">[SELECIONE]</option>
                                        <option v-for="g in customer_groups" :value="g.id" :key="g.id">{{g.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Situação</label><br/>

                                    <div class="form-check form-check-inline">
                                        <input type="radio" id="inlineRadio1" v-model="search_params.is_active" value="all" class="form-check-input">
                                        <label class="form-check-label" for="inlineRadio1">Todos</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" id="inlineRadio2" v-model="search_params.is_active" value="active" class="form-check-input">
                                        <label class="form-check-label" for="inlineRadio2">Ativos</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" id="inlineRadio3" v-model="search_params.is_active" value="inactive" class="form-check-input">
                                        <label class="form-check-label" for="inlineRadio3">Inativos</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="$appUtils.isMobile() && !filterMode" class="grid-mobile">
                            <div v-for="c in search.entries" class="item" :key="c.id">
                                <span class="nm ellipsis">{{c.name}}</span>
                                <span class="ft ellipsis">
                                    <span class="label">Nome Fant.</span>
                                    {{c.commercial_name}}
                                </span>

                                <div class="gp t-r">
                                    <span class="label">Grupo</span>
                                    {{c.group}}
                                </div>

                                <div class="city t-r">
                                    <span class="label">Cidade</span>
                                    {{c.city}}
                                </div>

                                <div class="doc">
                                    <span class="label">Doc.</span>
                                    {{c.document | formatDocument}}
                                </div>

                                <div class="p" v-if="isAnyAdmin && c.total_paid">
                                    <span class="label">Pago</span>
                                    <div class="income t-c">{{c.total_paid | formatMoney}}</div>
                                </div>
                                <div class="np" v-if="isAnyAdmin && c.total_unpaid">
                                    <span class="label">Não Pago</span>
                                    <div class="outcome t-c">{{c.total_unpaid | formatMoney}}</div>
                                </div>
                                <div class="acc" v-if="c.customer_accounts && c.customer_accounts.length > 0">
                                    <span class="label">Contas</span>
                                    <div class="tag-container acc">
                                        <span class="account-tag c-p" v-for="a in c.customer_accounts" :key="a.id" :title="`${a.bank_name}, Ag.: ${a.agency} / Cc.: ${a.number}`">
                                            <b>{{a.bank_code}}</b>: <span>Ag.: <b>{{a.agency}}</b></span>/<span>Cc.: <b>{{a.number}}</b></span>
                                        </span>
                                    </div>
                                </div>

                                <div class="act">
                                    <button type="button"
                                            class="btn btn-sm"
                                            title="Editar"
                                            @click="edit(c.id)">
                                        <svg-icon icon="pencil-alt"/>
                                    </button>
                                    <button type="button"
                                            class="btn btn-sm"
                                            title="Remover"
                                            @click="confirmDestroy(c.id, $event)">
                                        <svg-icon icon="trash-alt"/>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div ref='end_grid' v-if="$appUtils.isMobile()">
                            <FabMenuCrud :is-open="!filterMode && isOpenFabMenu"
                                         url-new="/customers/new"
                                         v-if="!filterMode"
                                         @onExpand="isOpenFabMenu = !isOpenFabMenu"
                                         @onFilter="(is) => {
                                         filterMode = is;
                                         isOpenFabMenu = false;
                                         }"/>

                            <div class="t-c">
                                <svg-icon v-if="searching" icon="sync" class="refresh load-more-crud"/>
                            </div>
                        </div>
                    </template>

                    <template v-slot:footer>
                        <div class="row" v-if="filterMode || !$appUtils.isMobile()">
                            <div class="col-sm-12 t-r">
                            <span class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                    <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon icon="sync"/> Limpar</button>
                                    <router-link to="/customers/new" class="btn btn-dark btn-sm"><svg-icon icon="plus"/> Criar Novo</router-link>
                                    <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                                </span>
                            </div>
                        </div>
                        <div class="row" v-if="$appUtils.isDesktop()">
                            <div class="col-sm-12">
                                <br/>
                                <Pagination
                                        :page_size="search.per_page"
                                        :current_page="search.current_page"
                                        :total_entries="search.total_entries"/>

                                <Loading :visible="searching"/>
                                <table class="table table-hover table-striped table-sm table-bordered">
                                    <thead class="thead-dark thead-center">
                                    <tr>
                                        <th>Razão Social</th>
                                        <th >Nome Fantasia</th>
                                        <th>Grupo</th>
                                        <th>Cidade</th>
                                        <th>CNPJ/CPF</th>
                                        <th v-if="isAnyAdmin" style="width: 80px">Pago</th>
                                        <th v-if="isAnyAdmin" style="width: 80px">Não Pago</th>
                                        <th>Contas</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="search && search.entries">
                                    <tr v-for="c in search.entries" :key="c.id" class="line-item">
                                        <td class="v-m c-p ellipsis f-w-700" @click="edit(c.id)">{{c.name}}</td>
                                        <td class="v-m c-p ellipsis" @click="edit(c.id)">{{c.commercial_name}}</td>
                                        <td class="v-m c-p f-w-700" @click="edit(c.id)">{{c.group}}</td>
                                        <td class="v-m c-p ellipsis" @click="edit(c.id)">{{c.city}}</td>
                                        <td class="v-m c-p t-c" @click="edit(c.id)">{{c.document | formatDocument}}</td>
                                        <td v-if="isAnyAdmin" class="v-m c-p t-r income" @click="edit(c.id)">{{c.total_paid | formatMoney}}</td>
                                        <td v-if="isAnyAdmin" class="v-m c-p t-r outcome" @click="edit(c.id)">{{c.total_unpaid | formatMoney}}</td>
                                        <td class="v-m p-r o-x-h">
                                            <div class="tag-container">
                                                <span class="account-tag c-p" v-for="a in c.customer_accounts" :key="a.id" :title="`${a.bank_name}, Ag.: ${a.agency} / Cc.: ${a.number}`">
                                                    <b>{{a.bank_code}}</b>: <span>Ag.: <b>{{a.agency}}</b></span>/<span>Cc.: <b>{{a.number}}</b></span>
                                                </span>
                                            </div>

                                            <div class="actions btn-group btn-group-xs">
                                                <button type="button"
                                                        class="btn btn-xs btn-danger"
                                                        title="Remover"
                                                        @click="confirmDestroy(c.id, $event)">
                                                    <svg-icon icon="trash-alt"/>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <Pagination
                                        :page_size="search.per_page"
                                        :current_page="search.current_page"
                                        :total_entries="search.total_entries"/>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>
        </template>
        <template v-slot:footer>
            <BottomMenuMob v-if="$appUtils.isMobile() && !filterMode"/>
        </template>
    </DefaultTmpl>
</template>

<script>
    import Pagination from '@/components/Pagination'
    import CRUDSearch from '@/mixins/CRUDSearch'
    import {createNamespacedHelpers} from 'vuex'
    import FabMenuCrud from "../../components/particles/FabMenuCrud";
    import BottomMenuMob from "../../components/particles/BottomMenuMob";
    import Loading from "../../components/particles/Loading";
    const {mapActions, mapGetters} = createNamespacedHelpers('customers');


    export default {
        name: "CustomersSearch",
        components: {
            Loading,
            FabMenuCrud,
            Pagination,
            BottomMenuMob
        },
        mixins: [
            CRUDSearch.mount('customers')
        ],
        data() {
            return {
                isOpenFabMenu: false,
            }
        },
        methods: {
            ...mapActions(['loadCustomerGroups']),
            createSearchParams() {
                return {
                    query: '',
                    customer_group_id: '',
                    is_active: 'all'
                }
            },
            getIntersectItemListener() {
                return this.$refs.end_grid;
            }
        },
        computed: {
            ...mapGetters(['customer_groups']),
            isAnyAdmin() {
                return this.$appStorage.userIsProfile(['admin', 'admin_all', 'admin_view'])
            }
        },
        mounted() {
            this.loadCustomerGroups();
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/variables";

    .income {
        color: $income_main_color;
    }
    .outcome {
        color: $fixed_expenses_main_color
    }

    .tag-container {
        width: 100%;
        max-width: 100%;
        max-height: 22px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        overflow-x: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .account-tag {
            background-color: $theme_color_eight;
            color: #fff;
            display: inline-block;
            max-height: 22px;
            border-radius: 5px;
            padding-left: 3px;
            padding-right: 3px;
            white-space: nowrap;
            cursor: pointer;

            &:not(:first-child) {
                margin-left: 5px;
            }
        }
    }

    .grid-mobile .item {
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        grid-template-areas: "nm nm" "ft gp" "doc city" "p np" 'acc acc' 'act act';
        grid-gap: 5px;
        font-size: .8em;
        padding: 5px;

        .label {
            display: block;
            text-align: center;
            font-weight: bold;
            font-size: .8em;
        }

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .nm {
            grid-area: nm;
            text-align: center;
            font-weight: bold;
        }
        .ft {
            grid-area: ft;
        }

        .gp {
            grid-area: gp;
        }

        .doc {
            grid-area: doc;
        }
        .city {
            grid-area: city;
        }

        .p {
            grid-area: p;
        }

        .np {
            grid-area: np;
        }

        .acc {
            grid-area: acc;
        }

        .act {
            grid-area: act;
            text-align: right;

            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }

            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
